import React from 'react';
import PropTypes from 'prop-types';
import { Attachments } from '../../../dashboardCommon/components';
import { apiHost } from '../../../../utils/request';

// Contract PDF removed with the CS signing retirement — same as myOrdersDashboardCS (FR-012a).
const pdfLinks = [
  {
    label: 'Proposal PDF',
    getUrl: (orderId, locale) =>
      `${apiHost}/orders/${orderId}/proposal-pdf?lang=${locale}`
  }
];

const Attachements = props => (
  <Attachments
    {...props}
    pdfLinks={pdfLinks}
    cardHeaderTitle="Proposal PDF"
  />
);

Attachements.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.shape({})).isRequired
};

export default Attachements;
